var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquarestack3Dupfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.086 2.774 31.758 33.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "ob-sf-square-stack-3d-up-fill-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.922C0 21.797 0.859 23.418 3.418 24.902L18.125 33.457C18.379 33.613 18.711 33.711 18.965 33.711C19.199 33.711 19.531 33.613 19.805 33.457L34.492 24.902C37.031 23.438 37.91 21.797 37.91 19.922C37.91 18.047 37.031 16.426 34.492 14.941L22.656 8.047C21.25 7.227 20.078 6.934 18.965 6.934C17.832 6.934 16.66 7.227 15.254 8.047L3.418 14.941C0.879 16.426 0 18.047 0 19.922Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ob-sf-square-stack-3d-up-fill-cut1",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.969C0 14.844 0.859 16.465 3.418 17.949L18.125 26.504C18.379 26.66 18.711 26.758 18.965 26.758C19.199 26.758 19.531 26.66 19.805 26.504L34.492 17.949C37.031 16.484 37.91 14.844 37.91 12.969C37.91 11.094 37.031 9.473 34.492 7.988L22.656 1.094C21.25 0.274 20.078 0 18.965 0C17.832 0 16.66 0.274 15.254 1.094L3.418 7.988C0.879 9.473 0 11.094 0 12.969Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ob-sf-square-stack-3d-up-fill-cut1)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#ob-sf-square-stack-3d-up-fill-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98 29.199L16.797 36.074C17.617 36.543 18.262 36.758 18.965 36.758C19.668 36.758 20.293 36.543 21.113 36.074L32.949 29.199C34.316 28.379 34.844 27.773 34.844 26.875C34.844 25.957 34.316 25.352 32.949 24.531L21.113 17.656C20.293 17.188 19.668 16.973 18.965 16.973C18.262 16.973 17.617 17.188 16.797 17.656L4.98 24.531C3.594 25.352 3.086 25.957 3.086 26.875C3.086 27.773 3.594 28.379 4.98 29.199Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.98 22.246L16.797 29.141C17.617 29.609 18.262 29.824 18.965 29.824C19.668 29.824 20.293 29.609 21.113 29.141L32.949 22.246C34.316 21.445 34.844 20.84 34.844 19.922C34.844 19.004 34.316 18.399 32.949 17.578L21.113 10.703C20.293 10.234 19.668 10.02 18.965 10.02C18.262 10.02 17.617 10.234 16.797 10.703L4.98 17.578C3.594 18.399 3.086 19.004 3.086 19.922C3.086 20.84 3.594 21.445 4.98 22.246Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98 15L16.797 21.875C17.617 22.344 18.262 22.559 18.965 22.559C19.668 22.559 20.293 22.344 21.113 21.875L32.949 15C34.316 14.18 34.844 13.574 34.844 12.656C34.844 11.758 34.316 11.133 32.949 10.332L21.113 3.457C20.293 2.969 19.668 2.774 18.965 2.774C18.262 2.774 17.617 2.969 16.797 3.457L4.98 10.332C3.594 11.133 3.086 11.758 3.086 12.656C3.086 13.574 3.594 14.18 4.98 15Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarestack3Dupfill);
export default __webpack_public_path__ + "static/media/square.stack.3d.up.fill.50a31e859415d366b4c7050ed046d308.svg";
export { ForwardRef as ReactComponent };